import {
    FETCH_VEHICLES,
    FETCH_VEHICLES_SUCCESS,

    FETCH_VEHICLE_DETAILS,
    FETCH_VEHICLE_DETAILS_SUCCESS,

    ADD_NEW_VEHILCE,
    ADD_NEW_VEHILCE_SUCCESS,

    ADD_NEW_VEHILCE_SERVICE,
    ADD_NEW_VEHILCE_SERVICE_SUCCESS
} from "../actions/types";

import _ from "lodash"

const testVehilces = [
    {
        vehicleNumber: "SJ - 7754",
        engineCapacity: "1000",
        chassisNumber: "554454545",
        mileage: 2500,
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/job-images/image-1aa262cb-3a87-41f5-ac67-abc75a5886e0-1566547152444",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000,
                mileage: 25000
            }
        ]
    },
    {
        assetName: "Computer Table",
        assetNumber: "CT-20",
        assetDescription: "",
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/job-images/image-1aa262cb-3a87-41f5-ac67-abc75a5886e0-1566547152444",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000
            }
        ]
    },
    {
        vehicleNumber: "JJ - 2500",
        engineCapacity: "198.88",
        chassisNumber: "554454545",
        mileage: 2500,
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/job-images/image-8c99afc7-4fbd-4d89-ae96-9116bf0103cd-1564550476548",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000,
                mileage: 25000
            }
        ]
    },
    {
        vehicleNumber: "HG - 7754",
        engineCapacity: "4000.88 cc",
        chassisNumber: "554454545",
        mileage: 2500,
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/job-images/3582DD8A-6AA9-4A65-943E-DBC300F1DE07-1560354378428",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000,
                mileage: 25000
            }
        ]
    },
    {
        vehicleNumber: "SD - 7754",
        engineCapacity: "8000",
        chassisNumber: "554454545",
        mileage: 2500,
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/job-images/image-3285e59d-f583-4fdc-8386-99742eddd2be-1560925389606",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000,
                mileage: 25000
            }
        ]
    },
    {
        vehicleNumber: "LK - 7754",
        engineCapacity: "8000",
        chassisNumber: "554454545",
        mileage: 2500,
        createdAt: "2019-11-18T05:53:04.249Z",
        image: "https://s3-ap-southeast-1.amazonaws.com/onawadak-production/user-profile-images/83477120-d4b7-4150-83fc-78c256d51baf-1578061040820",
        services: [
            {
                title: "Air filter change",
                description: "A motor vehicle service or tune-up is a series of maintenance procedures carried out at a set time interval or after the vehicle has traveled a certain distance.",
                createdAt: "2019-11-18T05:53:04.249Z",
                amout: 5000,
                mileage: 25000
            }
        ]
    }
]

const INITIAL_STATE = {
    vehicles: testVehilces,
    vehicleDetails: {},
    loadingVehicles: false,
    loadingVehicleDetails: false,
    loadingAddVehicle: false,
    loadingAddService: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_VEHICLES:
            return {
                ...state,
                loadingVehicles: true
            }
        case FETCH_VEHICLES_SUCCESS:
            return {
                ...state,
                vehicles: state.vehicles,
                loadingVehicles: false
            }
        case FETCH_VEHICLE_DETAILS:
            return {
                ...state,
                vehicleDetails: {},
                loadingVehicleDetails: true
            }
        case FETCH_VEHICLE_DETAILS_SUCCESS:
            console.log("KKKKKKKKK>:", action.payload.vehicleNumber)
            let result = _.find(state.vehicles, { 'vehicleNumber': action.payload.vehicleNumber });
            if (result === undefined) {
                result = _.find(state.vehicles, { 'assetNumber': action.payload.vehicleNumber });
            }
            return {
                ...state,
                vehicleDetails: result === undefined ? {} : result,
                loadingVehicleDetails: false
            }
        case ADD_NEW_VEHILCE:
            return {
                ...state,
                loadingAddVehicle: true
            }
        case ADD_NEW_VEHILCE_SUCCESS:
            const tempVehicles = state.vehicles
            tempVehicles.push(action.payload.vehicle)
            return {
                ...state,
                loadingAddVehicle: false,
                vehicles: tempVehicles
            }
        case ADD_NEW_VEHILCE_SERVICE:
            return {
                ...state,
                loadingAddService: true
            }
        case ADD_NEW_VEHILCE_SERVICE_SUCCESS:
            const service = action.payload.service
            let vehicle = {};
            if ("assetNumber" in state.vehicleDetails) {
                vehicle = _.find(state.vehicles, { 'assetNumber': state.vehicleDetails.assetNumber });
            } else {
                vehicle = _.find(state.vehicles, { 'vehicleNumber': state.vehicleDetails.vehicleNumber });
            }
            if ("services" in vehicle) {
                vehicle["services"] = [...vehicle["services"], service]
            } else {
                vehicle["services"] = [service]
            }
            return {
                ...state,
                loadingAddService: false,
                vehicleDetails: { ...vehicle },
            }
        default:
            return state
    }
}